/* eslint-disable @typescript-eslint/no-unused-vars */
import * as React from 'react';
import { css } from 'styled-components';
import { useBexApi } from '@shared-ui/bex-api-context';

// Cpds
import { Cpds } from '@Cpds.Ui';

// Sub Components
import {
  V3OneKeyComponentContainer,
  OnekeyImageContainer,
  Description,
  SignupContainer,
  SignupText,
} from '../styles/v3-one-key-component-style';

//helpers and hooks
import { getStore } from 'src/utils/store-utils';
import { checkValue } from 'src/components/common/helper';
import { useExtractSignupText } from '../hooks/useExtractSignupText';
import { useConstructCtaUrl } from '../hooks/useConstructCtaUrl';

//types
import { CpdsObjectFitType } from 'src/components/common/cpds/cpds-image/constants';
import { V3OneKeyComponentTemplateComponent } from '../typings';

const V3OneKeyComponent: React.FC<V3OneKeyComponentTemplateComponent> = ({ parentModuleId }) => {
  const data = getStore();
  const { context } = useBexApi();

  const { expUserId, authState } = context?.identity;

  const isSignInRequired = authState === 'ANONYMOUS' || expUserId === '-1';

  const ctaURL = useConstructCtaUrl(data?.onekeyCtaUrl, window, parentModuleId);
  const { signupCtaText, signupMesage } = useExtractSignupText(data?.onekeySignInMessageText);

  if (!checkValue(data?.onekeyDescription) && !checkValue(data?.onekeyLogo?.[0]?.url)) {
    return null;
  }

  return (
    <V3OneKeyComponentContainer className="v3-one-key-component-style-tag">
      <OnekeyImageContainer>
        <Cpds.Image
          exClasses="v3-one-key-image"
          src={data?.onekeyLogo?.[0]?.url}
          alt={'v3-one-key-image'}
          objectFit={CpdsObjectFitType.CPDS_COVER}
        />
      </OnekeyImageContainer>
      <Description>{data?.onekeyDescription}</Description>
      {isSignInRequired && (
        <>
          {checkValue(ctaURL) && checkValue(data?.onekeyCtaText) && (
            <Cpds.Button
              href={ctaURL}
              exClasses="v3-one-key-sign-in-button"
              buttonType="Primary"
              tag="a"
              buttonSize={'large'}
            >
              {data?.onekeyCtaText}
            </Cpds.Button>
          )}
          {checkValue(ctaURL) && checkValue(signupMesage) && (
            <SignupContainer>
              <SignupText>{signupMesage}</SignupText>
              {checkValue(signupCtaText) && (
                <Cpds.Button
                  href={ctaURL}
                  exClasses="v3-one-key-sign-up-button cpds-button-roman-book-11"
                  tag="a"
                  buttonSize={'small'}
                >
                  {signupCtaText}
                </Cpds.Button>
              )}
            </SignupContainer>
          )}
        </>
      )}
    </V3OneKeyComponentContainer>
  );
};

export default V3OneKeyComponent;
